import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EventsServiceService } from 'src/app/modules/events/events-service.service';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import * as moment from "moment-timezone";
import { TimePeriod } from 'ngx-daterangepicker-material/daterangepicker.component';

@Component({
  selector: 'app-entity-alerts',
  templateUrl: './entity-alerts.component.html',
  styleUrls: ['./entity-alerts.component.css']
})
export class EntityAlertsComponent implements OnInit, OnDestroy {
  @Input() entityId: string;

  columnHeader: any = {};
  alertsMaster: any = [];
  pager: any = {};
  currentPage: number = 1;
  periodList = [{ _id: 1, name: 'Today' }, { _id: 2, name: 'Last 7 days' }, { _id: 3, name: 'Last month' }, { _id: 4, name: 'Last 3 months' },
  { _id: 5, name: 'Last 6 months' }];
  period = new FormControl(this.periodList[0]);
  apiHitTime: Date;
  public datepickerForm: FormGroup;
  private _selectedDates = {
    from: null,
    to: null,
  };

  private _initializeForm(type: string = 'default') {
    this.datepickerForm = this._fb.group({
      thisdate: null
    });
  }
  private _entitiesMarkerList: any = [];
  private _startTime: any = null;
  private _subscription: Subscription;
  private _createServiceTicketSubscription: Subscription;
  private _alertListSubscription: Subscription;
  private _updateAlertSubscription: Subscription;
  pageSize: number = 10;


  constructor(public sharedService: ServicecallService, private _datePipe: DatePipe, private _eventsService: EventsServiceService, private _dataSer: DataService, private _fb: FormBuilder) {
    this._subscription = this._dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._getAlertData(this.currentPage);
      }
    });
  }

  ngOnInit(): void {
    this._entitiesMarkerList = this.sharedService.getConfiguration('trackerEntities') ? this.sharedService.getConfiguration('trackerEntities')['trackerEntitiesList'] : [];
    this.apiHitTime = new Date();
    this.columnHeader = this.sharedService.getConfiguration('tenantGenericConfig')?.eventsColumnHeader?.['entityAlert'] ? this.sharedService.getConfiguration('tenantGenericConfig')?.eventsColumnHeader?.['entityAlert'] : {};
    //Initializing Date-time range picker
    this._initializeForm();
    const { startDate, endDate } = this.sharedService.getConfiguration('tenantGenericConfig')?.defaultTimeRange
      ? this.sharedService.calculateDateRange(this.sharedService.getConfiguration('tenantGenericConfig').defaultTimeRange)
      : { startDate: this._startTime, endDate: new Date() };

    this.datepickerForm.setValue({
      thisdate: { startDate, endDate }
    });
    if (this.sharedService.getConfiguration('tenantGenericConfig').defaultTimeRange) {
      this._selectedDates = { from: startDate, to: endDate };
    }
    //Initializing Date-time range picker
    this.onPeriodFilterChange();
  }

  /**
   * Determines whether period filter change on
   */
  onPeriodFilterChange() {
    switch (this.period.value._id) {
      case 1:
        this._startTime = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
        break;
      case 2:
        this._startTime = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 7, 0, 0, 0, 999);
        break;
      case 3:
        this._startTime = new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0, 999);
        // this.endTime = new Date(new Date().getFullYear(),new Date().getMonth(), 0,23,59,59,999);
        break;
      case 4:
        this._startTime = new Date(new Date().getFullYear(), new Date().getMonth() - 3, 1, 0, 0, 0, 999);
        break;
      case 5:
        this._startTime = new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1, 0, 0, 0, 999);
        break;
    }
    this._getAlertData(1);
  }

  /**
   * Saves time
   * @param [data] 
   */
  saveTime(data?: any) {
    if (data) {
      let dateRange: TimePeriod = data;
      const offsetTime = new Date().getTimezoneOffset() * 60 * 1000;
      this._selectedDates.from = this._getTimestampInMillisecond(dateRange?.startDate?.toDate()) + (offsetTime)
      this._selectedDates.to = this._getTimestampInMillisecond(dateRange?.endDate?.toDate()) + (offsetTime)
      this.datepickerForm.setValue({
        thisdate: { startDate: this._selectedDates.from, endDate: this._selectedDates.to }
      });
    }
    this._getAlertData(1);
  }

  /**
   * Gets timestamp in millisecond
   * @param date 
   * @returns timestamp in millisecond 
   */
  private _getTimestampInMillisecond(date: Date): number {
    return date ? new Date(date)?.getTime() : 0;
  }


  /**
   * Tables action
   * @param actionType
   */
  tableAction(actionType: any) {
    if (actionType.type === "export") {
      const fields = Object.entries(this.columnHeader)?.map(([key, value]) => {
          if (key === 'action') return undefined;
          const label = typeof value === 'string' ? value
            : (value && typeof value === 'object' && 'name' in value)
              ? (value as any)?.name
              : '';
          const field: any = { label, value: key };
          if (key === 'time' || key === 'ackTime') {
            field['type'] = 'time';
          }
          return field;
        })
        .filter(Boolean);

      const req = {
        siteId: this.sharedService.getSiteId(),
        filterBy: "Alert",
        from: this._datePipe.transform(this._selectedDates?.from ?? this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
        to: this._datePipe.transform(this._selectedDates?.to ?? Date.now(), 'yyyy-MM-ddTHH:mm:ssZZ'),
        classType: "Alert",
        timezone: sessionStorage.getItem('selectedTimeZone') ? sessionStorage.getItem('selectedTimeZone') : moment.tz.guess(),
        exportFormat: actionType.item,
        entityId: this.entityId,
        exportFilename: "Alerts",
        entityCategory: this.sharedService.getConfiguration('tenantCategory') ? this.sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null,
        fields: [...fields]
      }
      this.sharedService.commonExport(actionType.item, req, 'alertsExport', 'Export_Alert_')

    } else {
      const { type, item } = actionType;
      if (type === "createIncident") {
        const reqData = {
          "alertId": +item?.alertId,
          "incidentParams": {
            "short_description": `${item?.entityName} ${item?.entityCategory} - ${item?.alert}`,
            "comments": "This is a incident created from iDEC",
            "urgency": "3",
            "state": "1",
            "caller_id": "167def90971031101889f5b3f153afaf"
          }
        };
        this._createServiceTicketSubscription = this.sharedService.createServiceTicket(reqData).subscribe({
          next: (data: any) => {
            if (data && data?.incidentNumber) {
              this.sharedService.toasterService({ type: 'success', msg: `${data?.incidentNumber} - Incident created successfully` });
            } else {
              this.sharedService.toasterService({ type: 'error', msg: `Unable to create a incident` });
            }
          },
          error: (error: any) => {
            this.sharedService.toasterService({ type: 'error', msg: `Unable to create a incident` });
          }
        });
        return;
      } else {
        const reqData = {
          status: false,
          id: actionType.item.id,
          state: actionType?.type !== 'actionTaken' ? actionType?.type : null
        }
        this._updateAlertSubscription = this._eventsService.updateAlert(reqData).subscribe((result: any) => {
          if (result['status']) {
            this.sharedService.toasterService({ type: 'success', msg: result["response"] });
            this._getAlertData(this.currentPage);
          }
        })
      }
    }
  }

  /**
   * Determines whether paginate change on
   * @param page
   */
  onPaginateChange(page: any) {
    this.currentPage = page;
    document.getElementById("launchScroll")?.scrollIntoView({ behavior: "smooth" });
    this._getAlertData(this.currentPage);
  }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription?.unsubscribe();
    }
    if (this._createServiceTicketSubscription) {
      this._createServiceTicketSubscription?.unsubscribe();

    }
    this._alertListSubscription?.unsubscribe();
    this._updateAlertSubscription?.unsubscribe();
  }

  /**
   * Gets alert data
   * @param pageNo
   */
  private _getAlertData(pageNo: any) {
    const reqData = {
      filterBy: "Alert",
      classType: "Alert",
      page: pageNo,
      autoClose: null,
      filterList: [],
      entityId: this.entityId,
      zoneId: null,
      from: this._datePipe.transform(this._selectedDates?.from ?? this._startTime, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(this._selectedDates?.to ?? new Date(), 'yyyy-MM-ddTHH:mm:ssZZ'),
      siteId: this.sharedService.getSiteId(),
      entityCategory: this.sharedService.getConfiguration('tenantCategory') ? this.sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null,
      limit: this.pageSize
    };
    this.apiHitTime = new Date();
    this._alertListSubscription = this.sharedService.alertList(reqData).subscribe((result: any) => {
      if (result['status']) {
        if (result['response'].length) {
          this.alertsMaster = [...result['response']];
          this.alertsMaster.map((item: any) => {
            item.originalTime = item.time;
            item.time = this.sharedService.getLastSeenFormat(item?.time);
            item.status = item.status === true ? 'Active' : 'Acknowledged';
            item.ackBy = item.ackBy ? item.ackBy : "--";
            item.ackTime = item.ackTime !== 'null' ? this.sharedService.getLastSeenFormat(item?.ackTime) : "--";
            item.vehicle = "KL01BX-- -- --";
            item.entityType = 'alerts';
            item.entityModule = this._setEntityType(item.entityCategory);
            item.destination = item.destination ? item.destination : '--';
            item.attributeValue = item.attributeValue ? '' + item.attributeValue : "--";
          });
        }
        else {
          this.alertsMaster = [];
        }
        if (result['pageInfo']) {
          this.pager = { ...result['pageInfo'] };
        }
      } else {
        this.alertsMaster = [];
        this.sharedService.toasterService({ type: 'error', msg: result?.response?.message });
      }
    });
  }

  /**
   * Sets entity type
   * @param category 
   * @returns  
   */
  private _setEntityType(category: any) {
    const filteredEntityEntityModule = this._entitiesMarkerList.find((entity: any) => entity.entityCategory === category);
    return filteredEntityEntityModule ? this._setRoute(+filteredEntityEntityModule.entityModule) : '';
  }
 
  /**
   * Sets route
   * @param entityModule 
   * @returns  
   */
  private _setRoute(entityModule: number) {
    switch (entityModule) {
      case 1: return 'vehicles';
      case 2: return 'assets';
      case 3: return 'people';
      default: return 'assets';
    }
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize; // Update pageSize based on user selection
    this._getAlertData(1); // Fetch data again with the new page size
  }

}
